import { api } from "../utils/api";
import type { RestDeviceConfig } from "@KassaroAB/shared/types/deviceConfig";
import type { StoreId } from "@KassaroAB/shared/types/ids";

export const getDeviceConfigsApi = async (
  storeId: StoreId,
): Promise<RestDeviceConfig[]> => {
  return api.get(`stores/${storeId}/deviceConfigs`);
};

